import { History } from "history";
import queryStringParser from "query-string";

export interface ICarsParsedQuery {
    isTravelApp?: boolean;
}

export const parseQueryFromString = (
  queryString: string
): ICarsParsedQuery => {
    const {
        isTravelApp,
    } = queryStringParser.parse(queryString);

    return {
        isTravelApp: isTravelApp === "true",
    };
};

export const parseQueryString = (
  history: History
): ICarsParsedQuery | null => {
    const queryString = history?.location?.search || "";
    return queryString ? parseQueryFromString(queryString) : null;
};
